(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["checkout-lock"] && !Shopify.designMode) return;
  try {
    (function () {
    var dialog = document.getElementById('checkout-lock-dialog');
    if (!dialog) return;

    var closeBtn = dialog.querySelector('.checkout-lock__close');
    var emailForm = dialog.querySelector('form');
    var inputGroup = document.getElementById('checkout-lock-inputs');
    var successMsg = document.getElementById('checkout-lock-success');

    function openDialog() {
      dialog.showModal();
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        dialog.close();
      });
    }

    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) dialog.close();
    });

    document.addEventListener('click', function (e) {
      if (dialog.contains(e.target)) return;

      var link = e.target.closest('a');
      if (link && link.href && link.href.includes('/checkout')) {
        e.preventDefault();
        e.stopImmediatePropagation();
        openDialog();
        return;
      }

      var checkoutBtn = e.target.closest('[name="checkout"]');
      if (checkoutBtn) {
        e.preventDefault();
        e.stopImmediatePropagation();
        openDialog();
      }
    }, true);

    document.addEventListener('submit', function (e) {
      if (dialog.contains(e.target)) return;
      var action = e.target.getAttribute('action') || '';
      var hasCheckoutBtn = e.target.querySelector('[name="checkout"]');
      if (action.includes('/checkout') || hasCheckoutBtn) {
        e.preventDefault();
        e.stopImmediatePropagation();
        openDialog();
      }
    }, true);

    function overlayPaymentButtons() {
      document.querySelectorAll('[data-shopify="payment-button"], .shopify-payment-button').forEach(function (el) {
        if (el.dataset.checkoutLocked) return;
        el.dataset.checkoutLocked = 'true';
        el.style.position = 'relative';
        var overlay = document.createElement('div');
        overlay.className = 'checkout-lock-btn-overlay';
        overlay.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopImmediatePropagation();
          openDialog();
        });
        el.appendChild(overlay);
      });
    }

    overlayPaymentButtons();
    new MutationObserver(overlayPaymentButtons).observe(document.body, { childList: true, subtree: true });

    if (emailForm) {
      emailForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var formData = new FormData(emailForm);
        fetch(emailForm.action, {
          method: 'POST',
          body: formData,
          headers: { 'Accept': 'application/json' }
        }).then(function () {
          if (inputGroup) inputGroup.hidden = true;
          if (successMsg) successMsg.hidden = false;
        }).catch(function () {
          if (inputGroup) inputGroup.hidden = true;
          if (successMsg) successMsg.hidden = false;
        });
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
